//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { communityType, publishType } from '../utils/dictionary'
import { getScore } from '@/api/community'
import { communityMixin } from '@/views/community/utils/communityMixin'

export default {
  name: 'CommunityLayout',
  mixins: [communityMixin],
  data () {
    return {
      reward: undefined,
      unreadMessage: true,
      communityType: communityType,
      publishType: publishType,
      activeList: ''
    }
  },
  computed: {
    key () {
      if (this.$route.matched.length === 3) {
        return this.$route.fullPath
      }
    }
  },
  created () {
    this.getUserScore()
  },
  methods: {
    handleSelectPage (val) {
      this.activeList = ''
      this.activePage = val
      this.$router.push({
        path: '/community/list',
        query: {
          activePage: this.activePage
        }
      })
    },
    handleSelectList (val) {
      this.activePage = ''
      this.activeList = val
      this.$router.push({
        path: '/community/publishList',
        query: {
          publishType: this.activeList
        }
      })
    },
    getUserScore () {
      getScore({
        id: this.$_communityMixin_employeeNo
      }).then(res => {
        if (res.data.code === '200') {
          this.reward = res.data.data.amount
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/community/components/CommunityLayout.vue